// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Av73","name":"Header_name__1aAtv","birthday":"Header_birthday__3fY-L","skeleton":"Header_skeleton__1arnb"};